import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";


export class SetFormValidAction extends BaseAction<void, { isValid: boolean }> {
    override async run(): Promise<void> {
        try {
            const { isValid } = this.params!;
            updateRecoilState("isPersonalInfoFormValidAtom", isValid);
        } catch (error) {
            console.error("Error in SetFormValidAction:", error);
        }
    }
}

export const setFormValidAction = new SetFormValidAction();